<template>
  <div class="flex items-center">
    <div class="flex w-full bg-white rounded shadow">
      <select class="relative px-6 py-3 w-full rounded-r focus:shadow-outline form-select" autocomplete="off" name="Team" placeholder="Select Team" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
        <option
          v-for="team in teams"
          :key="team.value"
          :value="team.label"
        >
          {{ team.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
    teams: Array,
  },
  emits: ['update:modelValue'],
}
</script>
